/**
 * The name of the frozen, full-access role.
 *
 * This is a *name-keyed* contract, not an ID one: the engine finds the Admin
 * role by name to force-sync its permissions on every boot
 * (`RolePermissionsSyncService`) and to reject edits and deletes
 * (`AdminRoleFrozenError`). Helm keys off the same name to decide whether to
 * show admin-only navigation and to suppress controls the engine will refuse.
 *
 * It lived as a bare `"Admin"` literal in five places across the engine, the
 * seed and Helm. A name-keyed contract duplicated by copy-paste is exactly the
 * drift this package exists to prevent, so it is centralised here.
 */
export const ADMIN_ROLE_NAME = "Admin"
